import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { EmailHubService } from 'src/app/private/services/email-hub.service';
import { LeadService } from 'src/app/private/services/lead.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';
import { UploadService } from 'src/app/private/services/upload.service';
import { LeadActivityService } from 'src/app/private/services/lead-activity.service';
import { buildCommunicationLogPayload, CommunicationLogPayload, extractCommunicationLogId } from 'src/app/utils/communication-log.util';
import {
  getApiErrorMessage,
  isMailboxLinkRequiredMessage,
  isMailboxLinkRequiredResponse,
  showMailboxLinkRequiredToast,
} from 'src/app/utils/mail-hub-response.util';
import { tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
@Component({
  selector: 'app-lead-email',
  templateUrl: './lead-email.component.html',
  styleUrls: ['./lead-email.component.scss']
})
export class LeadEmailComponent {
  files: any[] = [];
  public Editor = ClassicEditor as unknown as any;

  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() communicationLogged = new EventEmitter<void>();
  @Input() communicationData: any;

  @Output() openConnectEmail: EventEmitter<any> = new EventEmitter();
  btnLoading = false;
  templateSelection: string = 'custom'; // Default to custom template
  editorData: string = ''; // CKEditor data
  selectedTemplate: string | null = null;
  templates: any[] = [];
  emailSubject: string = '';
  isFetchingTemplates = false;
  sanitizedData: SafeHtml = '';
  btnLoading2 = false;
  notes: string = '';
  btnLoading3 = false;
  emails: string[] = [];
  templateDataToSend: any = {};
  currentSingature: any = '';

  @ViewChild('Content1') content1: any;
  @ViewChild('PreviewTemplate') PreviewTemplate: any;
  sendUsingOutlook: boolean = false;
  sendUsingSES: boolean = false;


  userData: any = {
    contact_name: 'Gaurav',
    contact_phone: '123-456-7890',
    company_name: 'YourCompany'
  };

  uploadingFiles: any[] = [];
  attachments: any[] = [];
  isAdmin: boolean = false;
  private communicationLogId: number | null = null;

  constructor(
    private toast: ToastrService,
    private api: LeadService,
    private emailHub: EmailHubService,
    private localStorage: LocalStorageService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private tracker: TrackingService,
    private uploadService: UploadService,
    private leadActivity: LeadActivityService
  ) {
    this.isAdmin = this.localStorage.checkFullAccessForTableList(
      this.localStorage.getRole()
    );
  }

  public editorConfig = {
    placeholder: 'Type your email content here...',
    toolbar: [
      'bold', 'italic', 'underline', '|',
      'undo', 'redo', '|',
    ],
    image: {
      resizeOptions: [
        {
          name: 'resizeImage:original',
          label: 'Original',
          value: null
        },
        {
          name: 'resizeImage:50',
          label: '50%',
          value: '50'
        },
        {
          name: 'resizeImage:75',
          label: '75%',
          value: '75'
        }
      ],
      toolbar: ['imageStyle:inline', 'imageStyle:block', 'imageStyle:side', '|', 'resizeImage', '|', 'imageTextAlternative']
    }
  };


  onReady(editor: any) {
    // Set custom upload adapter (optional, as you have)
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
      return new UploadAdapter(loader);
    };

    // Custom behavior: replace default Enter with Shift+Enter
    editor.editing.view.document.on(
      'enter',
      (evt: any, data: any) => {
        editor.execute('shiftEnter'); // insert <br> instead of <p>
        data.preventDefault();        // cancel default enter
        evt.stop();                   // stop further handling
      },
      { priority: 'high' }
    );
  }



  ngOnInit() {
    console.log('Communication Data:', this.communicationData);
    this.handleGetTemplates();

    let signature = this.localStorage.getSignatures();
    signature.forEach((element: any) => {
      if (element.isActive === true || element.isActive === 'true') {
        this.currentSingature = element.signature;
        this.editorData = `<br><br><br><br>${this.currentSingature}`
      }
    });


    let permissions = this.localStorage.getPermissions();

    // ✅ Ensure permissions is an array
    if (typeof permissions === 'string') {
      permissions = JSON.parse(permissions);
    }

    const hasMailHub = permissions?.some((module: any) =>
      module.module_name === 'sales-mail-hub' && module.active
    );

    const hasDomainAuth = permissions?.some((module: any) =>
      module.module_name === 'setting' &&
      module.features?.some((f: any) => f.name === 'domain_authentication' && f.active)
    );

    this.sendUsingOutlook = hasMailHub;
    this.sendUsingSES = hasDomainAuth;

    if (this.sendUsingOutlook && this.sendUsingSES) {
      this.sendUsingOutlook = true;
      this.sendUsingSES = false;
    }



  }

  handleGetTemplates() {
    // Get templates from API
    const data: any = {
      "client_id": this.localStorage.getClientId()
    }

    if (!this.isAdmin) {
      data['user_id'] = this.localStorage.getUserId();
    }

    this.api.getAllEmailTemplates(data).subscribe((res: any) => {
      this.templates = res;
    }
    );
  }

  onEditorChange() {
    // Handle CKEditor data change
  }

  onTemplateChange(event: any) {
    console.log('Selected Template:', event.target.value);
  }

  processAction(content: any) {

    if (this.emailSubject === '') {
      this.toast.error('Please enter email subject');
      return;
    }

    if (this.templateSelection === 'custom') {
      console.log('Custom Email Content:', this.editorData);
      if (this.editorData === '') {
        this.toast.error('Please enter email content');
        return;
      }
    } else {
      if (this.selectedTemplate === null) {
        this.toast.error('Please select a template');
        return;
      }
    }

    // this.btnLoading = true;
    // // Simulate a process or API call
    // setTimeout(() => {
    //   this.btnLoading = false;
    //   console.log('Action processed');
    // }, 2000);

    if (this.templateSelection !== 'custom') {
      console.log('Selected Template:', this.selectedTemplate);
      this.handleGetEmailTemplateById(this.selectedTemplate);
    }


    this.modalService
      .open(content, {
        size: 'md', scrollable: true, centered: true,
        backdrop: 'static', keyboard: false
      })
  }

  handleGetEmailTemplateById(id: any) {
    this.isFetchingTemplates = true;
    const payload = {
      "client_id": this.localStorage.getClientId(),
      "template_id": id
    }
    this.api.getEmailTemplateById(payload).subscribe(
      (res: any) => {
        let updatedBody = res.template_body
        for (const key in this.communicationData) {
          if (this.communicationData.hasOwnProperty(key)) {
            const value = this.communicationData[key];
            // Replace the placeholder (e.g., {{contact_name}}) with the corresponding value
            const placeholder = `{{${key}}}`;
            const regex = new RegExp(placeholder, 'g');
            updatedBody = updatedBody.replace(regex, value);
          }
        }
        this.templateDataToSend = updatedBody;
        this.sanitizedData = this.sanitizer.bypassSecurityTrustHtml(updatedBody);
        this.tracker.track("Preview", "Email Template", `Template previewed: ${res.template_name || res.template_id}`);


        console.log('sanitizedData Data 123:', this.sanitizedData);

        this.isFetchingTemplates = false
      },
      (error: any) => {
        this.isFetchingTemplates = false
        console.error('Error creating campaign', error);

      }

    );
  }

  private finishLeadEmailSendSuccess(toLabel: string, isCustom: boolean): void {
    this.toast.success('Email sent successfully');
    this.btnLoading2 = false;
    const desc = isCustom
      ? `Email sent to ${toLabel} using custom content`
      : `Email sent to ${toLabel} using template: ${this.selectedTemplate}`;
    this.tracker.track('Send', 'Lead Email', desc);
    this.persistEmailCommunicationLog('').subscribe({
      next: () => {
        this.notifyCommunicationLogged();
        this.modalService.open(this.content1, {
          size: 'lg',
          scrollable: true,
          centered: true,
          backdrop: 'static',
          keyboard: false,
        });
      },
      error: (err) => {
        console.error('Failed to save email communication history', err);
        this.toast.error('Email sent, but communication history could not be saved');
        this.modalService.open(this.content1, {
          size: 'lg',
          scrollable: true,
          centered: true,
          backdrop: 'static',
          keyboard: false,
        });
      },
    });
  }

  private buildEmailLogPayload(note: string): CommunicationLogPayload {
    return buildCommunicationLogPayload(this.localStorage, {
      lead_id: this.communicationData?.lead_id,
      communication_type: 'email',
      note,
      status: 'Sent',
      email_extra_details: {
        subject: this.emailSubject,
        template_id: this.selectedTemplate,
        template_name: this.selectedTemplate,
        attachments: (this.attachments || []).map((file) => ({
          fileName: file.fileName,
          presignedUrl: file.presignedUrl,
        })),
        email_content: this.editorData,
        to: this.communicationData?.contact_email,
      },
    });
  }

  private persistEmailCommunicationLog(note: string): Observable<any> {
    const leadId = this.communicationData?.lead_id;
    if (!leadId) {
      return of(null);
    }

    const payload = this.buildEmailLogPayload(note);
    return this.api.CreateCommunicationHisLog(payload).pipe(
      tap((res: unknown) => {
        const logId = extractCommunicationLogId(res);
        if (logId) {
          this.communicationLogId = logId;
          this.leadActivity
            .recordCommunication(
              leadId,
              logId,
              'email',
              note || this.emailSubject,
              payload.status
            )
            .subscribe();
        }
      })
    );
  }

  private notifyCommunicationLogged(): void {
    this.communicationLogged.emit();
  }

  Submit() {
    this.btnLoading2 = true;
    const ep = this.localStorage.getEmailProviderTypeForPayload();
    const displayName = this.localStorage.getProfileName() || 'Gravitas AI';
    const hubUserEmail = this.localStorage.getMailHubUserEmail();
    const sesAddr = this.localStorage.getSendEmailFromAddress();
    const fromForSes = `"${displayName}" <${sesAddr}>`;

    try {
      const isCustom = this.templateSelection === 'custom';
      const bodyHtml = isCustom ? this.editorData : this.templateDataToSend;
      const recipientEmails = isCustom
        ? this.emails?.length > 0
          ? this.emails
          : [this.communicationData?.contact_email]
        : [this.communicationData?.contact_email];
      const filteredRecipients = recipientEmails.filter(Boolean);
      const toLabel = filteredRecipients.join(', ');
      const sesTo =
        filteredRecipients.length === 1
          ? filteredRecipients[0]
          : filteredRecipients.join(',');

      if (!['OUTLOOK', 'GMAIL', 'SES'].includes(ep)) {
        this.toast.error('Select a mailbox (Outlook, Gmail, or SES) in communication preferences.');
        this.btnLoading2 = false;
        return;
      }

      const handleMailboxLinkRequired = (message: string): boolean => {
        if (!isMailboxLinkRequiredMessage(message)) {
          return false;
        }
        this.modalService.dismissAll();
        this.openConnectEmail.emit();
        showMailboxLinkRequiredToast(this.toast, message);
        this.btnLoading2 = false;
        return true;
      };

      const onMailHubLinkRequired = (res: { message?: string }) => {
        return handleMailboxLinkRequired(getApiErrorMessage(res) || res?.message || '');
      };

      const onSendError = (e: unknown) => {
        const message = getApiErrorMessage(e);
        if (handleMailboxLinkRequired(message)) {
          return;
        }
        console.log(e);
        this.toast.error(message || 'Error sending email');
        this.btnLoading2 = false;
      };

      if (ep === 'OUTLOOK') {
        const outlookParam = {
          subject: this.emailSubject,
          contentType: 'HTML' as const,
          bodyContent: bodyHtml,
          recipientEmails: filteredRecipients,
          user_email: hubUserEmail,
          ccRecipients: [] as string[],
          attachments: isCustom ? this.attachments : [],
          client_id: this.localStorage.getClientId(),
        };
        this.emailHub.sendEmailUsingOutlook(outlookParam).subscribe({
          next: (res: any) => {
            if (onMailHubLinkRequired(res)) return;
            this.finishLeadEmailSendSuccess(toLabel, isCustom);
          },
          error: onSendError,
        });
        return;
      }

      if (ep === 'GMAIL') {
        const gmailAttachments = (this.attachments || [])
          .map((file: any) => ({
            filename: file.fileName || file.name,
            presigned_url: file.presignedUrl,
          }))
          .filter((a: { presigned_url?: string }) => !!a.presigned_url);
        const gmailPayload: {
          client_id: string;
          user_email: string;
          to: string;
          subject: string;
          body: string;
          attachments?: { filename: string; presigned_url: string }[];
        } = {
          client_id: this.localStorage.getClientId(),
          user_email: hubUserEmail,
          to: toLabel,
          subject: this.emailSubject,
          body: bodyHtml,
        };
        if (gmailAttachments.length) {
          gmailPayload.attachments = gmailAttachments;
        }
        this.emailHub.sendEmailUsingGmail(gmailPayload).subscribe({
          next: (res: any) => {
            if (onMailHubLinkRequired(res)) return;
            this.finishLeadEmailSendSuccess(toLabel, isCustom);
          },
          error: onSendError,
        });
        return;
      }

      const sesPayload = {
        client_id: this.localStorage.getClientId(),
        subject: this.emailSubject,
        text: '',
        html: bodyHtml,
        from_email: fromForSes,
        to: sesTo,
        attachments: (this.attachments || []).map((file: any) => ({
          filename: file.fileName,
          path: file.presignedUrl,
        })),
      };
      this.api.sendEmail(sesPayload).subscribe({
        next: (res: unknown) => {
          if (isMailboxLinkRequiredResponse(res)) {
            onSendError(res);
            return;
          }
          this.finishLeadEmailSendSuccess(toLabel, isCustom);
        },
        error: onSendError,
      });
    } catch {
      this.btnLoading2 = false;
    }
  }

  closeModal() {
    this.close.emit();
  }

  closeModal2() {
    this.btnLoading2 = false;
    this.modalService.dismissAll();
  }

  async onFileSelected(event: any) {
    const selectedFiles: FileList = event.target.files;

    for (let i = 0; i < selectedFiles.length; i++) {
      const file = selectedFiles[i];

      if (file.size > 4 * 1024 * 1024) {
        console.warn(`File "${file.name}" exceeds 4MB limit.`);
        alert(`"${file.name}" is too large. Max file size is 4MB.`);
        continue;
      }

      const fileInfo = {
        fileName: file.name,
        mimeType: file.type,
        uploading: true,
        success: false,
        error: false,
        fileRef: file, // optional: keep ref to file
      };

      this.uploadingFiles.push(fileInfo);

      // ⬇️ Kick off upload IMMEDIATELY, don't await here
      this.uploadFileParallel(file, fileInfo);
    }
  }


  async uploadFileParallel(file: File, fileInfo: any) {
    try {
      const presignedUrl = await this.uploadToS3(file);

      // Update status
      fileInfo.uploading = false;
      fileInfo.success = true;

      // Push to final attachments
      this.attachments.push({
        fileName: file.name,
        mimeType: file.type,
        presignedUrl,
      });
    } catch (error) {
      fileInfo.uploading = false;
      fileInfo.error = true;
      console.error('Upload failed for', file.name, error);
    }
  }


  async uploadToS3(file: File): Promise<string> {
    console.log('Uploading file:', file);
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      // const folder = `education/students/documents`;
      const folder = `crm/leads/attachments`;
      formData.append('file', file);
      formData.append('folders', folder);
      formData.append('bucket', 'global-upload-storage');

      this.uploadService.uploadDcouments(formData).subscribe({
        next: (response: any) => {
          console.log('File uploaded successfully:', response);
          resolve(response.url); // Assuming API returns { url: 's3-url' }
        },
        error: (error) => {
          console.error('Error uploading file:', error);
          reject('');
        },
      });
    });
  }

  // Remove a File from the List
  removeFile(index: number) {
    this.files.splice(index, 1);
    this.uploadingFiles.splice(index, 1);
  }

  // Helper: Check if File is an Image
  isImage(file: File): boolean {
    return file.type.startsWith('image/');
  }

  // Helper: Check if File is a Video
  isVideo(file: File): boolean {
    return file.type.startsWith('video/');
  }

  // Helper: Format File Size for Display
  formatSize(size: number): string {
    if (size < 1024) return `${size} B`;
    else if (size < 1048576) return `${(size / 1024).toFixed(2)} KB`;
    else return `${(size / 1048576).toFixed(2)} MB`;
  }

  saveNotes() {
    try {
      this.btnLoading3 = true;
      const leadId = this.communicationData?.lead_id;
      if (!leadId) {
        this.toast.error('Lead not found');
        this.btnLoading3 = false;
        return;
      }

      const finish = () => {
        this.notifyCommunicationLogged();
        this.modalService.dismissAll();
        this.btnLoading3 = false;
      };

      if (this.communicationLogId) {
        this.api
          .UpdateCommunicationHisLog({
            id: this.communicationLogId,
            note: this.notes,
          })
          .subscribe({
            next: () => {
              this.toast.success('Remark saved successfully');
              this.notifyCommunicationLogged();
              finish();
            },
            error: () => {
              this.toast.error('Error saving remark');
              this.btnLoading3 = false;
            },
          });
        return;
      }

      const payload = this.buildEmailLogPayload(this.notes);
      this.api.CreateCommunicationHisLog(payload).subscribe({
        next: (res: any) => {
          this.toast.success('Notes saved successfully');
          const desc = `Saved email communication note for lead ID: ${leadId} | To: ${this.communicationData?.contact_email} | Subject: ${this.emailSubject}`;
          this.tracker.track('Save', 'Email Note', desc);
          const logId = extractCommunicationLogId(res);
          if (logId) {
            this.communicationLogId = logId;
            this.leadActivity
              .recordCommunication(
                leadId,
                logId,
                'email',
                this.notes || this.emailSubject,
                payload.status
              )
              .subscribe({ next: finish, error: finish });
          } else {
            finish();
          }
        },
        error: () => {
          this.toast.error('Error saving communication history');
          this.btnLoading3 = false;
        },
      });
    } catch (e) {
      this.btnLoading3 = false;
      this.toast.error('Error saving notes');
      console.error(e);
    }
  }


}


export class UploadAdapter {
  private loader: any;

  constructor(loader: any) {
    this.loader = loader;
  }

  public async upload(): Promise<any> {
    const file = await this.loader.file;
    const dataUrl = await this.readThis(file);
    return { default: dataUrl };
  }

  private readThis(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
      reader.readAsDataURL(file);
    });
  }




}
